<template>
    <div class="line-config">
        <el-dialog
            :close-on-click-modal="false"
            :visible.sync="lineDialogVisible"
            width="920px"
            center
            v-if="lineDialogVisible"
            custom-class="dialog"
            :before-close="cancelVisible"
        >
		<div class="" slot="title" style="text-align: left;font-size: 20px;font-family: PingFang SC Medium-, PingFang SC Medium;font-weight: normal;color: #282F36;line-height: 25px;">
			视频配置
		</div>
            <el-table :data="config" size="medium" height="300px">
                <el-table-column prop="state" label="线路选择" align="center" width="80">
                    <template slot-scope="scope">
                        <el-switch v-model="scope.row.state" @change="onChange(scope.row)"> </el-switch>
                    </template>
                </el-table-column>
                <el-table-column prop="type" label="画面显示" align="center">
					<template slot-scope="scope">
						{{scope.row.name}}
					<!-- 	{{
							scope.row.type === 'START_LATER'?'画面1-会议稍后开始':scope.row.type === 'ONGOING'?'画面2-直播画面':scope.row.type === 'TESTING'?'画面3-会议测试中':scope.row.type === 'ENDED'?'画面4-会议结束':scope.row.type === 'VOD'?'画面5-直播回放':''
						}} -->
						</template>
				</el-table-column>
                <el-table-column prop="rtmpPullUrl" label="拉流地址" align="center">
                    <template slot-scope="scope">
                        <el-tooltip class="item" effect="light" content="点击复制地址" placement="top-end">
                            <span @click="copy(scope.row.rtmpPullUrl)" class="copy" style="overflow: hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-line-clamp: 2;line-clamp: 2;-webkit-box-orient: vertical;">{{ scope.row.rtmpPullUrl }}</span>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <el-table-column prop="pushDomainName" label="推流域名" align="center"></el-table-column>
                <el-table-column prop="livePushUrl" label="推流地址" align="center">
                    <template slot-scope="scope">
                        <el-tooltip class="item" effect="light" content="点击复制地址" placement="top-end">
                            <span @click="copy(scope.row.livePushUrl)" class="copy" style="overflow: hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-line-clamp: 2;line-clamp: 2;-webkit-box-orient: vertical;">{{ scope.row.livePushUrl }}</span>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <el-table-column label="操作" align="center">
                    <template slot-scope="scope">
                        <el-button type="text" @click="editLine(scope.row)">编辑线路</el-button>
						<el-button v-if="!scope.row.state" type="text" @click="deleteLine(scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
			 
            <span slot="footer" class="dialog-footer">
				<el-button icon="el-icon-plus" @click="addLine" style="margin-bottom:10px;width: 120px;" >添加线路</el-button>
                <!-- <el-button type="primary" plain @click="cancelVisible">取 消</el-button> -->
				<!-- style="background:#de4d2a !important" -->
                <!-- <el-button style="width: 120px;" type="primary" @click="sureAppoint" :loading="loading">确 定</el-button> -->
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { appointLine,deleteLineWholeInfo } from '@/serve/live';
export default {
    components: {},
    data() {
        return {
            loading: false,
            copyData: null,
            lineSelection: {}
        };
    },
    props: {
        lineDialogVisible: Boolean,
        config: {
            type: Array,
            default: () => []
        }
    },
    watch: {
        // config(newVal, oldVal) {
        //     if (newVal.length) {
        //         this.lineSelection = this.config.find(item => item.state);
        //     }
        // }
    },
    methods: {
        cancelVisible() {
            this.$emit('cancelVisible', 'lineDialogVisible', false);
        },
        addLine() {
            this.$emit('add', 'centerDialogVisible', false);
        },
        editLine(row) {
            this.addLine();
            this.$emit('edit',row);
        },
        copy(data) {
            let url = data;
            let oInput = document.createElement('input');
            oInput.value = url;
            document.body.appendChild(oInput);
            oInput.select(); // 选择对象;
            document.execCommand('Copy'); // 执行浏览器复制命令
            this.$message({
                message: '复制成功',
                type: 'success'
            });
            oInput.remove();
        },
        // 线路切换
        onChange(row) {
            
            this.lineSelection = row;
            this.config.forEach(item => {
                if (item.id !== row.id) {
                    item.state = false;
                }
            });
			this.sureAppoint();
        },
        // 使用指定线路信息
        sureAppoint() {
            let bool = this.config.some(item => item.state);
            if (!this.config.length) {
                return this.$message.warning('您还没有添加线路呢！');
            }
            if (!bool) {
                return this.$message.warning('请先选择一条线路!');
            }
            this.loading = true;
            appointLine(this.lineSelection.meetingId, this.lineSelection.id)
                .then(() => {
                    this.loading = false;
                    // this.cancelVisible();
                    this.$message.success('线路切换成功!');
					console.log("jin");
					
                })
                .catch(err => {
                    this.loading = false;
                    this.$message.error(err.data.message);
                });
				
        },
		deleteLine(row){
			console.log("row:",row);
			this.$confirm('此操作将删除该线路, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				customClass: 'del-model',
				type: 'warning'
			}).then(() => {
				deleteLineWholeInfo(row.meetingId, row.id)
				    .then(() => {
				        this.loading = false;
				        // this.cancelVisible();
				        this.$message.success('线路删除成功!');
						this.$emit('defaultSet');
				    })
				    .catch(err => {
				        this.loading = false;
				        this.$message.error(err.data.message);
				    });
			});
			
			
		}
    }
};
</script>
<style scoped lang="scss">
	::v-deep .el-table .cell{
		display: -webkit-box;
		-webkit-line-clamp: 2;
		overflow: hidden;
		text-overflow: ellipsis;
		-webkit-box-orient: vertical;
	}
.line-config {
    /* .el-button {
        margin: 10px 0;
    } */
	
    .el-table {
        ::v-deep .el-table__row ::v-deep .cell {
            display: -webkit-box;
            -webkit-line-clamp: 2;
            overflow: hidden;
            text-overflow: ellipsis;
            -webkit-box-orient: vertical;
        }
        .el-button {
            ::v-deep span {
                color: #2766FF;
                font-size: 12px;
                margin-right: 10px;
                &:hover {
                    border-bottom: 1px solid #2766FF;
                }
            }
        }
		
    }
    .copy {
        cursor: pointer;
        &:hover {
            text-decoration: underline;
        }
    }
}
.el-dialog__headerbtn .el-dialog__close {
    color: rgba(40,47,54,0.3);
	font-size: 20px;
}
</style>
